import { PageHero } from "@/components/common/PageHero";
import { FrameworkInteractive } from "@/components/home/FrameworkInteractive";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import { FRAMEWORK, IMAGES } from "@/lib/content";

export default function Framework() {
  return (
    <>
      <PageHero
        kicker="From Vision to Victory"
        title="The HATCH Framework™ for building successful India operations."
        subtitle="Five stages that turn a complex, multi-year journey into a clear, manageable path — mapping every customer need to Pixel-Hatch support and a real business outcome."
        image={IMAGES.leadership}
      />

      <section className="section-pad" data-testid="framework-interactive-section">
        <div className="container-px">
          <SectionHeading
            kicker="Explore Each Stage"
            title="Need → Support → Outcome"
            subtitle="Select a stage to see how we move you forward."
            center
          />
          <FrameworkInteractive />
        </div>
      </section>

      {/* Vertical journey */}
      <section className="section-pad border-t border-white/10 bg-[#131316]" data-testid="framework-journey">
        <div className="container-px">
          <SectionHeading kicker="The Journey" title="How the five stages connect" center />
          <div className="relative mx-auto max-w-3xl">
            <div className="absolute left-6 top-0 h-full w-px bg-gradient-to-b from-orange-500/50 via-amber-500/30 to-transparent" />
            {FRAMEWORK.map((s, i) => (
              <Reveal key={i} i={i}>
                <div className="relative mb-8 flex gap-6 pl-0">
                  <div className="z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl grad-accent font-head text-lg font-extrabold text-[#1a0f00]">
                    {s.letter}
                  </div>
                  <div className="rounded-2xl border border-white/8 bg-white/[0.02] p-6">
                    <div className="kicker mb-1">Stage {i + 1}</div>
                    <h3 className="font-head text-xl font-bold text-white">{s.title}</h3>
                    <p className="mt-3 text-sm text-zinc-400"><span className="text-zinc-500">Need — </span>{s.need}</p>
                    <p className="mt-2 text-sm text-zinc-400"><span className="text-orange-400">Support — </span>{s.support}</p>
                    <p className="mt-2 text-sm text-zinc-400"><span className="text-amber-400">Outcome — </span>{s.outcome}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
